import { useState, type FormEvent } from "react";
import { KeyRound } from "lucide-react";
import { Button, Input, Label } from "@tsi/ui";
import { useSession } from "../context/SessionContext";
import { CampoSenhaNova, validarSenhaNova } from "./CampoSenhaNova";
import { TelaAuth } from "./TelaAuth";

/** Primeiro acesso com a senha que veio de outra pessoa: cria a própria antes de usar o sistema. */
export default function CriarSenhaView() {
  const { usuario, trocarSenha, sair } = useSession();
  const [atual, setAtual] = useState("");
  const [nova, setNova] = useState("");
  const [confirmacao, setConfirmacao] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    const invalida = validarSenhaNova(nova, confirmacao);
    if (invalida) return setErro(invalida);
    if (nova === atual) return setErro("Escolha uma senha diferente da que você recebeu.");
    setErro(null);
    setEnviando(true);
    try {
      await trocarSenha(atual, nova);
    } catch (err) {
      setErro(err instanceof Error ? err.message : "Não foi possível salvar a senha");
    } finally {
      setEnviando(false);
    }
  }

  const primeiro = usuario?.nome.trim().split(/\s+/)[0];
  return (
    <TelaAuth>
      <form onSubmit={onSubmit} className="flex w-full max-w-[380px] flex-col gap-5">
        <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-50 text-brand">
          <KeyRound className="h-6 w-6" />
        </span>
        <div className="mb-1">
          <h1 className="text-[28px] font-semibold tracking-tight">Crie sua senha{primeiro ? `, ${primeiro}` : ""}</h1>
          <p className="mt-1.5 text-[14px] leading-relaxed text-muted-foreground">
            Você entrou com a senha que recebeu. Para continuar, crie uma senha só sua.
          </p>
        </div>
        <div className="flex flex-col gap-1.5">
          <Label htmlFor="atual">Senha que você recebeu</Label>
          <Input id="atual" type="password" autoComplete="current-password" value={atual} onChange={(e) => setAtual(e.target.value)} required />
        </div>
        <CampoSenhaNova nova={nova} confirmacao={confirmacao} onNova={setNova} onConfirmacao={setConfirmacao} />
        {erro && <p className="rounded-xl bg-rose-50 px-3 py-2 text-sm text-rose-700">{erro}</p>}
        <Button type="submit" size="lg" disabled={enviando}>
          {enviando ? "Salvando…" : "Salvar e entrar"}
        </Button>
        <button type="button" onClick={() => void sair()} className="text-center text-[13px] text-muted-foreground hover:text-foreground">
          Sair
        </button>
      </form>
    </TelaAuth>
  );
}
